import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

export const StyledATag = styled(Link)(() => ({
  color: 'unset',
  textDecoration: 'none'
}))
